import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Row, Col, Tooltip } from 'antd';
import { HappyProvider } from '@ant-design/happy-work-theme';
import { socket } from '../socket';

export function ConnectForm ({ setUsername, setRoomname  }) {

  const [values, setValues] = useState({ username: '', roomname: '' }); // Állapot a form értékeinek tárolásához
  const [form] = Form.useForm();
  function onFinish(values) {
    // Az értékek beállítása a belső állapotban
    setValues(values);
    // Az értékek átadása az App.js állapotaiba
    setUsername(values.username);
    setRoomname(values.roomname);
    
    
    socket.auth = {
      username: values.username,
      roomname: values.roomname,
    }
    socket.connect();

    localStorage.setItem('username', values.username);
    localStorage.setItem('roomname', values.roomname);
  }

  useEffect(() => {
    // Ellenőrizzük, hogy van-e mentett felhasználónév és szobanév a localStorage-ban
    const savedUsername = localStorage.getItem('username');
    const savedRoomname = localStorage.getItem('roomname');

    if (savedUsername && savedRoomname) {
      // Ha van mentett adat, akkor töltsük be az űrlapba
      form.setFieldsValue({ username: savedUsername, roomname: savedRoomname });
    }
  }, [form]);



  return (
    
            <HappyProvider>
              <Form name="login-form" form={form} initialValues={{ remember: true }} onFinish={onFinish}>
                <Form.Item
                  name="username"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter your name!',
                    },
                  ]}
                >
                  <Input placeholder="In game name" />
                 
                </Form.Item>
                 <Form.Item
                  name="roomname"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter the room name!',
                    },
                  ]}
                >
                  <Input placeholder="Room name" />
                
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit" className="submit-button">
                    Join
                  </Button>
                </Form.Item>
              </Form>
            </HappyProvider>
  );
};


